// The Wizzo lead phone rule (chat #4692): the same algorithm as api/src/utils/phone.js, which
// is the real gate on the server. Change one, change the other.
//
//   checkMobile(raw, israeliOnly) -> { ok: true, phone } | { ok: false, reason: 'missing' | 'invalid' }
//
// This landing is Hebrew, so the default is an Israeli mobile only; `phone` is the normalised
// number (0528472915), the value that is written back into the field and sent.

export const PHONE_MSG = {
  missing: 'נא להזין מספר נייד',
  invalid: 'מספר נייד לא תקין: 10 ספרות שמתחילות ב-05',
};

export function checkMobile(raw, israeliOnly = true) {
  const v = raw === undefined || raw === null ? '' : String(raw);
  if (!v.trim()) return { ok: false, reason: 'missing' };
  if (v.length > 40) return { ok: false, reason: 'invalid' };

  const intl = /^\s*(\+|00)/.test(v);
  let d = v.replace(/\D/g, '').replace(/^00/, '');
  const israeli = d.startsWith('972') || (!intl && d.startsWith('0'));
  if (d.startsWith('972')) d = '0' + d.slice(3).replace(/^0+/, '');

  if (/^05\d{8}$/.test(d)) {
    // a made-up number: the 7 digits after 05X are one digit repeated, or a run
    const tail = d.slice(3);
    if (/^(\d)\1{6}$/.test(tail) || tail === '1234567' || tail === '7654321') return { ok: false, reason: 'invalid' };
    return { ok: true, phone: d };
  }

  if (israeliOnly || israeli || d.length < 9 || d.length > 15) return { ok: false, reason: 'invalid' };
  return { ok: true, phone: (intl ? '+' : '') + d };
}
